export const userTentangMessages = {
    LOAD_FAILED: "Failed to load profile content. Please try again.",
    CREATE_SUCCESS: "Profile content created successfully!",
    CREATE_FAILED: "Failed to create profile content. Please try again.",
    UPDATE_SUCCESS: "Profile content updated successfully!",
    UPDATE_FAILED: "Failed to update profile content. Please try again.",
    DELETE_SUCCESS: "Profile content deleted successfully!",
    DELETE_FAILED: "Failed to delete profile content. Please try again.",
    EMPTY_DESCRIPTION: "Description cannot be empty.",
  };

export const userTaksMessages = {
    LOAD_FAILED: "Failed to load tasks. Please try again.",
    CREATE_SUCCESS: "Task created successfully!",
    CREATE_FAILED: "Failed to create task. Please try again.",
    UPDATE_SUCCESS: "Task updated successfully!",
    UPDATE_FAILED: "Failed to update task. Please try again.",
    DELETE_SUCCESS: "Task deleted successfully!",
    DELETE_FAILED: "Failed to delete task. Please try again.",
    EMPTY_DESCRIPTION: "Task description cannot be empty.",
  };
  